module.exports = __webpack_public_path__ + "img/arrow.e93f5b93.svg";